class Objetivo{
    constructor(id, articulo_id, cantidad, desde, hasta, detalle, articulo){
        this.id = id;
        this.articulo_id = articulo_id;
        this.cantidad = cantidad;
        this.desde = desde;
        this.hasta = hasta;
        this.detalle = detalle;
        this.articulo = articulo;
    }
}
export default Objetivo;